import React from 'react';
import Confirm from "v4/components/ui/Confirm/Confirm";
import {usePolTranslation} from "v4/hooks/usePolTranslation";
import 'v4/pages/front/Prospect/components/ProspectTabsSwitcher/components/partials/ProspectQuotesReoffer/ProspectQuotesReoffer.scss';
import useProspectQuotesReoffer
    from "v4/pages/front/Prospect/components/ProspectTabsSwitcher/components/partials/ProspectQuotesReoffer/hooks/useProspectQuotesReoffer";
import InlineLoader from "v4/components/ui/InlineLoader/InlineLoader";
import FormRender from "v4/components/form/FormRender/FormRender";

export default function ProspectQuotesReoffer({isReofferPopupOpen, rowIdToReoffer, closePopup, onReoffered}) {
    const {t} = usePolTranslation();
    const {
        formId,
        isFormLoading,
        isSubmitLoading,
        formErrors,
        onSubmit,
        setWithPdf,
        formData,
        methods,
    } = useProspectQuotesReoffer(rowIdToReoffer, closePopup, onReoffered);

    return (
        <Confirm title={t('refresh_quote')}
                 closeAction={closePopup}
                 isOpen={isReofferPopupOpen}
                 confirmAttr={{form: formId}}
                 confirmAction={() => setWithPdf(false)}
                 yesLabel="refresh_quote_only"
                 secondaryConfirmLabel="refresh_quote_and_regenerate_pdf"
                 secondaryConfirmAttr={{form: formId}}
                 secondaryConfirmAction={() => setWithPdf(true)}
                 isLoading={isSubmitLoading}>
            <p className="mb-4">{t('confirm_reoffer_quote')}</p>
            {isFormLoading || !formData
                ? <InlineLoader/>
                : (
                    <FormRender methods={methods} formId={formId} form={formData} formErrors={formErrors} onSubmit={onSubmit}/>
                )
            }
        </Confirm>
    )
}
